var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.24219 0 0 2.24219 0 5V30C0 32.7578 2.24219 35 5 35H30C32.7578 35 35 32.7578 35 30V5C35 2.24219 32.7578 0 30 0H5ZM28.2109 6.5625L20.1016 15.8281L29.6406 28.4375H22.1719L16.3281 20.7891L9.63281 28.4375H5.92188L14.5938 18.5234L5.44531 6.5625H13.1016L18.3906 13.5547L24.5 6.5625H28.2109ZM25.2578 26.2188L11.9844 8.66406H9.77344L23.1953 26.2188H25.25H25.2578Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social Twitter.6171a48cea00f473e2f9c5972602e49d.svg";
export { ForwardRef as ReactComponent };